import { ShieldCheck, Shield, Headset } from "lucide-react";

const ValuesSection = () => {
    return (
        <section className="values-section">
            <div className="container">

                <div className="text-center mb-5">
                    <h2 className="values-title">NUESTROS VALORES</h2>
                </div>

                <div className="row g-4 justify-content-center">

                    {/* CONFIABILIDAD */}
                    <div className="col-lg-4 col-md-6">
                        <div className="value-card h-100 text-center">

                            <div className="value-icon">
                                <ShieldCheck size={40} />
                            </div>

                            <h5 className="value-heading">Confiabilidad</h5>

                            <p className="value-text">
                                Cumplimos lo que prometemos. Vehículos listos y en óptimas condiciones para garantizar una experiencia de alquiler segura y sin inconvenientes.
                            </p>

                        </div>
                    </div>

                    {/* SEGURIDAD */}
                    <div className="col-lg-4 col-md-6">
                        <div className="value-card h-100 text-center">

                            <div className="value-icon">
                                <Shield size={40} />
                            </div>

                            <h5 className="value-heading">Seguridad</h5>

                            <p className="value-text">
                                Tu tranquilidad es nuestra prioridad. Realizamos mantenimiento preventivo constante y brindamos asistencia permanente para cada viaje.
                            </p>

                        </div>
                    </div>

                    {/* SERVICIO */}
                    <div className="col-lg-4 col-md-6">
                        <div className="value-card h-100 text-center">

                            <div className="value-icon">
                                <Headset size={40} />
                            </div>

                            <h5 className="value-heading">Servicio al Cliente</h5>

                            <p className="value-text">
                                Atención personalizada y amable para resolver cualquier consulta o necesidad antes, durante y después de tu alquiler.
                            </p>

                        </div>
                    </div>

                </div>
            </div>

            <style>
                {`

        .values-section{
          background:#ffffff;
          padding:100px 0 50px 0;
        }

        .values-title{
          color:#d22222;
          font-weight:700;
          font-size:2.5rem;
          letter-spacing:1px;
        }

        .value-card{
          background:white;
          padding:40px 30px;
          border-radius:14px;
          transition:all .3s ease;
          box-shadow:0 10px 25px rgba(0,0,0,0.05);
        }

        .value-card:hover{
          transform:translateY(-6px);
          box-shadow:0 18px 40px rgba(0,0,0,0.1);
        }

        .value-icon{
          width:70px;
          height:70px;
          margin:auto;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:50%;
          background:#ffe9e9;
          color:#d22222;
          margin-bottom:20px;
        }

        .value-heading{
          font-weight:700;
          font-size:1.4rem;
          margin-bottom:12px;
        }

        .value-text{
          color:#6c757d;
          font-size:1.2rem;
          line-height:1.6;
        }

        `}
            </style>

        </section>
    );
};

export default ValuesSection;